var map = {
	"./documents/other-format": "./app/javascript/images/documents/other-format.jpg",
	"./documents/other-format.jpg": "./app/javascript/images/documents/other-format.jpg",
	"./documents/pdf-format": "./app/javascript/images/documents/pdf-format.png",
	"./documents/pdf-format.jpg": "./app/javascript/images/documents/pdf-format.jpg",
	"./documents/pdf-format.png": "./app/javascript/images/documents/pdf-format.png",
	"./documents/times": "./app/javascript/images/documents/times.svg",
	"./documents/times.svg": "./app/javascript/images/documents/times.svg",
	"./emails/facebook": "./app/javascript/images/emails/facebook.png",
	"./emails/facebook.png": "./app/javascript/images/emails/facebook.png",
	"./emails/img-footer-agora": "./app/javascript/images/emails/img-footer-agora.jpg",
	"./emails/img-footer-agora.jpg": "./app/javascript/images/emails/img-footer-agora.jpg",
	"./emails/instagram": "./app/javascript/images/emails/instagram.png",
	"./emails/instagram.png": "./app/javascript/images/emails/instagram.png",
	"./emails/linkedin": "./app/javascript/images/emails/linkedin.png",
	"./emails/linkedin.png": "./app/javascript/images/emails/linkedin.png",
	"./emails/logo-edone": "./app/javascript/images/emails/logo-edone.png",
	"./emails/logo-edone-marrone": "./app/javascript/images/emails/logo-edone-marrone.png",
	"./emails/logo-edone-marrone.png": "./app/javascript/images/emails/logo-edone-marrone.png",
	"./emails/logo-edone.png": "./app/javascript/images/emails/logo-edone.png",
	"./emails/pinterest": "./app/javascript/images/emails/pinterest.png",
	"./emails/pinterest.png": "./app/javascript/images/emails/pinterest.png",
	"./emails/youtube": "./app/javascript/images/emails/youtube.png",
	"./emails/youtube.png": "./app/javascript/images/emails/youtube.png",
	"./logos/email-header": "./app/javascript/images/logos/email-header.jpg",
	"./logos/email-header.jpg": "./app/javascript/images/logos/email-header.jpg",
	"./logos/facebook": "./app/javascript/images/logos/facebook.svg",
	"./logos/facebook.svg": "./app/javascript/images/logos/facebook.svg",
	"./logos/logo-edone": "./app/javascript/images/logos/logo-edone.svg",
	"./logos/logo-edone-black-header": "./app/javascript/images/logos/logo-edone-black-header.svg",
	"./logos/logo-edone-black-header.jpg": "./app/javascript/images/logos/logo-edone-black-header.jpg",
	"./logos/logo-edone-black-header.svg": "./app/javascript/images/logos/logo-edone-black-header.svg",
	"./logos/logo-edone-email": "./app/javascript/images/logos/logo-edone-email.png",
	"./logos/logo-edone-email-white": "./app/javascript/images/logos/logo-edone-email-white.png",
	"./logos/logo-edone-email-white.png": "./app/javascript/images/logos/logo-edone-email-white.png",
	"./logos/logo-edone-email.png": "./app/javascript/images/logos/logo-edone-email.png",
	"./logos/logo-edone-email.svg": "./app/javascript/images/logos/logo-edone-email.svg",
	"./logos/logo-edone-white": "./app/javascript/images/logos/logo-edone-white.png",
	"./logos/logo-edone-white-email": "./app/javascript/images/logos/logo-edone-white-email.svg",
	"./logos/logo-edone-white-email.svg": "./app/javascript/images/logos/logo-edone-white-email.svg",
	"./logos/logo-edone-white.png": "./app/javascript/images/logos/logo-edone-white.png",
	"./logos/logo-edone-white.svg": "./app/javascript/images/logos/logo-edone-white.svg",
	"./logos/logo-edone.svg": "./app/javascript/images/logos/logo-edone.svg",
	"./logos/logo-enbilab": "./app/javascript/images/logos/logo-enbilab.svg",
	"./logos/logo-enbilab.svg": "./app/javascript/images/logos/logo-enbilab.svg",
	"./logos/logo-lapis": "./app/javascript/images/logos/logo-lapis.svg",
	"./logos/logo-lapis-black": "./app/javascript/images/logos/logo-lapis-black.png",
	"./logos/logo-lapis-black.png": "./app/javascript/images/logos/logo-lapis-black.png",
	"./logos/logo-lapis.svg": "./app/javascript/images/logos/logo-lapis.svg",
	"./logos/logo-nav": "./app/javascript/images/logos/logo-nav.png",
	"./logos/logo-nav.png": "./app/javascript/images/logos/logo-nav.png",
	"./logos/logo_edone": "./app/javascript/images/logos/logo_edone.svg",
	"./logos/logo_edone.svg": "./app/javascript/images/logos/logo_edone.svg",
	"./logos/pinterest": "./app/javascript/images/logos/pinterest.svg",
	"./logos/pinterest.svg": "./app/javascript/images/logos/pinterest.svg",
	"./logos/youtube": "./app/javascript/images/logos/youtube.svg",
	"./logos/youtube.svg": "./app/javascript/images/logos/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";